<script>
  import MunicipalMap from '../components/MunicipalMap.svelte'
  let map
</script>

<div class="map-wrap">
  <MunicipalMap />
</div>
